/**
 * Enemy definitions for the combat game.
 * Organised into zones matching the KS1/KS2 curriculum.
 * Each enemy has base stats, a topic it attacks with, and a loot table.
 * idleSprite / attackSprite: animated GIFs generated by generate-enemy-animations.js
 */

function e(id, name, hp, atk, def, spd, topic, xp, yr) {
  return {
    id, name,
    sprite:        `/enemy-${id}.png`,
    idleSprite:    `/enemy-${id}-idle.gif`,
    attackSprite:  `/enemy-${id}-attack.gif`,
    hp, maxHp: hp, attack: atk, defence: def, speed: spd,
    topic, xpReward: xp, yearGroup: yr,
  };
}

export const ZONES = [
  {
    id:    'meadow',
    name:  'Number Meadow',
    theme: '#22c55e',
    bg:    '/zone-meadow.png',
    ks:    1,
    enemies: [
      e('slime',    'Slime',       40,  8,  4,  6,  'addition',       20,  1),
      e('goblin',   'Goblin',      55,  10, 5,  10, 'subtraction',    28,  1),
      e('mushroom', 'Shroom',      70,  12, 8,  7,  'addition',       35,  2),
    ],
    boss: e('troll',   'Number Troll', 160, 18, 12, 8,  'addition',       100, 2),
  },
  {
    id:    'forest',
    name:  'Times Table Forest',
    theme: '#3b82f6',
    bg:    '/zone-forest.png',
    ks:    1,
    enemies: [
      e('wolf',    'Times Wolf',   75,  14, 8,  14, 'multiplication', 40,  2),
      e('snake',   'Divide Snake', 65,  12, 6,  18, 'division',       38,  3),
      e('golem',   'Stone Golem',  100, 16, 18, 6,  'multiplication', 55,  3),
    ],
    boss: e('hydra',   'Hydra',        220, 24, 16, 12, 'multiplication', 150, 3),
  },
  {
    id:    'castle',
    name:  'Fraction Castle',
    theme: '#a855f7',
    bg:    '/zone-castle.png',
    ks:    2,
    enemies: [
      e('knight_e', 'Dark Knight', 110, 20, 20, 10, 'fractions',      65,  4),
      e('wizard_e', 'Hex Wizard',  90,  24, 10, 20, 'division',       70,  4),
      e('gargoyle', 'Gargoyle',    95,  18, 14, 22, 'fractions',      75,  5),
    ],
    boss: e('lich',    'The Lich',     300, 30, 20, 16, 'fractions',      250, 5),
  },
  {
    id:    'volcano',
    name:  'Percentage Volcano',
    theme: '#ef4444',
    bg:    '/zone-volcano.png',
    ks:    2,
    enemies: [
      e('demon',   'Percent Demon', 120, 26, 16, 18, 'fractions',      90,  5),
      e('phoenix', 'Phoenix',       100, 28, 12, 26, 'multiplication', 95,  6),
      e('titan',   'Maths Titan',   150, 24, 24, 12, 'division',       110, 6),
    ],
    boss: e('dragon',  'The Dragon',   400, 36, 28, 20, 'fractions',      400, 6),
  },
];

/**
 * getEnemy(zoneId, enemyId)
 * Returns a fresh copy of an enemy (avoids mutating the template).
 */
export function getEnemy(zoneId, enemyId) {
  const zone = ZONES.find(z => z.id === zoneId);
  if (!zone) return null;
  const all  = [...zone.enemies, zone.boss];
  const tmpl = all.find(e => e.id === enemyId);
  return tmpl ? { ...tmpl, activeEffects: [] } : null;
}

/**
 * getRandomEnemy(zoneId)
 * Returns a random non-boss enemy from a zone.
 */
export function getRandomEnemy(zoneId) {
  const zone = ZONES.find(z => z.id === zoneId);
  if (!zone) return null;
  const pick = zone.enemies[Math.floor(Math.random() * zone.enemies.length)];
  return { ...pick, activeEffects: [] };
}
